var map = {
	"./brightpoint_icon_1.png": "32e8",
	"./brightpoint_icon_2.png": "ec33",
	"./brightpoint_icon_3.png": "e777",
	"./brightpoint_icon_active_1.png": "09dc",
	"./brightpoint_icon_active_2.png": "57fc",
	"./brightpoint_icon_active_3.png": "4a92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a40";